_   = require('underscore')
Vue = require('vue/dist/vue')

sortCollectionByKey = (collection) ->
  array   = []
  result  = {}

  _.each collection, (item, key) ->
    item.id = key
    array.push(item)

  array = _.sortBy(array, (item) -> item.id)

  _.each array, (item) -> result[item.id] = item

  result

module.exports =
  namespaced: true

  state:
    openedCollection: null
    openedItem:       null
    collections:
      default: {}

  getters:

    current: (state) ->
      return null unless state.openedCollection? && state.openedItem?

      state.collections[state.openedCollection][state.openedItem]

    hasPreviousItem: (state) ->
      return false unless state.openedCollection? && state.openedItem?

      keys  = _.keys(state.collections[state.openedCollection])
      index = _.indexOf(keys, state.openedItem)

      if index - 1 >= 0 then true else false

    hasNextItem: (state) ->
      return false unless state.openedCollection? && state.openedItem?

      keys = _.keys(state.collections[state.openedCollection])
      index = _.indexOf(keys, state.openedItem)

      if index + 1 < _.size(keys) then true else false

  mutations:

    _setItem: (state, payload) ->
      collection = _.extend({}, state.collections[payload.collection] || {})
      collection[payload.id] or= {}
      collection[payload.id].thumbUrl = payload.thumbUrl || null
      collection[payload.id].imageUrl = payload.imageUrl || null
      collection[payload.id].title    = payload.title || null

      # Vue.set(state.collections, payload.collection, sortCollectionByKey(collection))
      Vue.set(state.collections, payload.collection, collection)

    _removeItem: (state, payload) ->
      return unless state.collections[payload.collection]?

      collection = _.extend({}, state.collections[payload.collection] || {})
      collection = _.omit(collection, payload.id)

      # Vue.set(state.collections, payload.collection, sortCollectionByKey(collection))
      Vue.set(state.collections, payload.collection, collection)

    _setOpenedCollection: (state, collection) ->
      Vue.set(state, 'openedCollection', collection)

    _setOpenedItem: (state, item) ->
      Vue.set(state, 'openedItem', item)

  actions:

    register: (context, payload) ->
      payload.collection  or= 'default'
      payload.id          or= _.uniqueId('lightbox-')

      context.commit('_setItem', payload)

    unregister: (context, payload) ->
      payload.collection or= 'default'

      context.commit('_removeItem', payload) if payload.id?

    open: (context, payload) ->
      context.commit('_setOpenedCollection', payload.collection)
      context.commit('_setOpenedItem', payload.id)

    close: (context) ->
      context.commit('_setOpenedCollection', null)
      context.commit('_setOpenedItem', null)

    openPrevious: (context) ->
      return unless context.state.openedCollection? && context.state.openedItem?
      keys  = _.keys(context.state.collections[context.state.openedCollection])
      index = _.indexOf(keys, context.state.openedItem)
      index -= 1
      return unless index >= 0
      context.dispatch('open', { collection: context.state.openedCollection, id: keys[index] })

    openNext: (context) ->
      return unless context.state.openedCollection? && context.state.openedItem?
      keys = _.keys(context.state.collections[context.state.openedCollection])
      index = _.indexOf(keys, context.state.openedItem)
      index += 1
      return unless index < _.size(keys)
      context.dispatch('open', { collection: context.state.openedCollection, id: keys[index] })








// WEBPACK FOOTER //
// ./assets/js/frontend/store/lightbox/index.coffee